export function roundToTwoDecimalPlaces(value: number | string | undefined) {
  if (value === undefined || value === null) {
    return '';
  }

  // Remove commas from string before converting
  const valueInNumber = typeof value === 'string' ? Number(value.replace(/,/g, '')) : Number(value);

  if (isNaN(valueInNumber)) {
    return '';
  }

  const numberInString = valueInNumber.toFixed(2);
  const [integerPart, decimalPart] = numberInString.split('.');

  const formattedIntegerPart = new Intl.NumberFormat().format(Number(integerPart));

  return `${formattedIntegerPart}.${decimalPart}`;
}

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: '2-digit' };
  return date.toLocaleDateString('en-US', options);
};

export const formatInvoiceDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US');
};
